module.exports = __webpack_public_path__ + "img/3.75128d0a.png";